<template>
  <div class="sidebar-content">
      <ul class="type-list clearfix">
        <li v-for="item in typeList" :key="item.id" class="type-item" >
          <!-- <span class="slash">|</span> -->
          <a link @click="goCourse(item)">{{ item.name }}</a>
        </li>
      </ul>
    <!--@click="showReg()"-->
      <!--<ul  class="course-list clearfix">-->
        <!--<li v-for="item in courseList" :key="item.id" class="course-item">-->
          <!--<course-item-mini :courseItem = "item"></course-item-mini>-->
        <!--</li>-->
      <!--</ul>-->
  </div>
</template>

<script>
  import { getCoursePid} from '@/api/course.js'
import dataMsg from 'mock/data.json'
import CourseItemMini from '@/components/course-item-mini/course-item-mini.vue'
export default {
  props: {
    typeList: {
      type: Array,
      default: function () {
        return []
      }
    },
    list: [],
  },
  components: {
    CourseItemMini
  },
  methods: {
    goCourse (item) {
      getCoursePid(item.id).then(res => {
        let routeData = this.$router.resolve({ path: '/CourseClassify',
          query: {
            courseTypeId: item.id,
            currentFirstId: res.data.parentId,
            // currentSecondId: item.id,
            status: 1,
            sourceType: 2,
            isOpen: 1
          } })
        window.open(routeData.href, '_self')
      })

    },

    showReg () {
      this.$alert('   正在开发中！', '敬请期待 ', {
        confirmButtonText: '确定',
      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import '~@/styles/base.scss';
.sidebar-content {
  padding-left: 60px;
  /*width: 960px;*/
  width:450px;
  height: 450px;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
  ul {
    overflow: hidden;
  }
  .link {
    position: relative;
    &::before {
      content: '|';
      top: -2px;
      left: -17px;
      color: #ccc;
      position: absolute;
    }
  }
  .type-list {
    .type-item {
      margin: 42px 30px 0 0;
      float: left;
      font-size: 14px;
      color: #333;
      cursor: pointer;
      &:hover {
      }
    }
  }
  .type-item a:hover{
    color: $layoutBlue;
    text-decoration: underline;
  }
  .course-list {
    position: absolute;
    bottom: 0;
    .course-item {
      float: left;
      margin: 0 60px 0 0;
      &:hover {
        transition: all 0.3s;
        transform: translate3d(0, -5px, 0);
        // box-shadow: 0 1px 5px #eee;
        .name {
          color: $layoutBlue !important;
        }
        .money {
          color: $layoutBlue !important;
        }
      }
    }
  }
 .slash {
   display: inline-block;
   color: #ccc;
   margin-left: 10px;
   font-size: 12px;
   line-height: 25px;
 }
}
</style>
<style>
  /*.el-message-box{*/
    /*position: absolute !important;*/
    /*top: 8% !important;*/
    /*left: 20px !important;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/views/home/components/sidebar-content.vue